<template>
  <div class="form-container">
    <div class="data-container">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
        <h3>订单客户信息</h3>
        <el-row :gutter="24">
          <el-col :span="12">
        <el-form-item label="客户名称" prop="customerId" >
          <el-input v-model="addForm.customerId" placeholder="请输入客户名称" style="width: 200px" readonly></el-input>
        </el-form-item>
          </el-col>
          <el-col :span="12">
        <el-form-item label="客户来源"  >
          <el-input v-model="this.customerSource" placeholder="请输入客户名称" style="width: 200px" readonly></el-input>
        </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
        <el-form-item label="客户级别" >
          <el-input v-model="this.customerLabel" placeholder="请输入客户名称" style="width: 200px" readonly></el-input>
        </el-form-item>
            </el-col>
            <el-col :span="12">
        <el-form-item label="客户销售渠道"  >
          <el-input v-model="this.customerType" placeholder="请输入客户名称" style="width: 200px" readonly></el-input>
        </el-form-item>
            </el-col>
          </el-row>
        <h3>订单数据</h3>
        <el-form-item label="订单编号" prop="orderSn">
          <span>{{ addForm.orderSn }}</span>
        </el-form-item>
        <el-form-item label="发货仓库" prop="stash">
          <el-input v-model="addForm.stash" style="width: 500px" placeholder="请输入发货仓">
          </el-input>
        </el-form-item>
        <div style="display: flex; align-items: center;">
          <h3>产品信息</h3>
          <el-button @click="showProductDialog" type="primary" icon="el-icon-s-goods" plain style="margin-left: 20px">选择产品</el-button>
        </div>
        <el-table :data="productList" v-loading="listLoading"  :border="true">
          <el-table-column prop="productName" label="产品名称" width="100" :align="'center'"></el-table-column>
          <el-table-column prop="picture" label="产品图片" width="130" :align="'center'">
            <template slot-scope="scope">
              <img :src="scope.row.picture" :preview-src-list="[scope.row.picture]" alt="Product Image"
                   style="width: 100px; height: 100px;">
            </template>
          </el-table-column>
          <el-table-column prop="price" label="产品价格" width="100" :align="'center'"></el-table-column>
          <el-table-column prop="costPrice" label="成本价" width="100" :align="'center'"></el-table-column>
          <el-table-column prop="productStock.stock" label="库存" width="100" :align="'center'"></el-table-column>
          <el-table-column label="采购数量(箱)"  :align="'center'">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.purchaseQuantity"
                  size="mini"
                  :min="0"
                  :controls="false"
                  :value="scope.row.purchaseQuantity || 0"
                  style="width: 100px"
                  @change="calculateOrderAmount(scope.row)"
              >
              </el-input-number>
            </template>
          </el-table-column>

          <el-table-column prop="salePrice" label="成交价(元)"  :align="'center'">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.salePrice"
                  size="mini"
                  :min="0"
                  :controls="false"
                  :value="scope.row.salePrice || 0.00"
                  style="width: 100px"
                  @change="calculateOrderAmount(scope.row)"
              >
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="订单金额(元)" width="110" :align="'center'">
            <template slot-scope="scope">
              {{ calculateOrderAmount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template scope="scope">
              <el-button type="text" size="mini" @click="cancelshowData(scope.row.id, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: left; font-weight: bold;">
          订单总金额: {{ totalOrderAmount.toFixed(2) }} 元
        </div>
        <div style="margin-top: 20px; text-align: left; font-weight: bold;">
          总采购数量: {{ purchaseNum }} 箱
        </div>
        <h3>物流信息</h3>
        <el-form-item label="快递公司" prop="logisticsCompanies">
          <el-input v-model="addForm.logisticsCompanies" style="width: 500px" placeholder="请输入快递公司">
          </el-input>
        </el-form-item>
        <el-form-item label="物流单号" prop="trackingNumber">
          <el-input v-model="addForm.trackingNumber" style="width: 500px" placeholder="请输入快递单号,也可以后续在输入">
          </el-input>
        </el-form-item>
        <el-form-item label="快递备注" prop="notes">
          <el-input v-model="addForm.remarks" type="textarea" :rows="3" style="width: 500px"
                    auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="订单备注" prop="notes">
          <el-input v-model="addForm.notes" type="textarea" :rows="3" style="width: 500px"
                    auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="发货方式" prop="logisticsMethods">
          <el-select v-model="addForm.logisticsMethods" filterable
                     allow-create default-first-option  clearable placeholder="请选择或手动输入发货方式">
            <el-option
                v-for="item in ShippingMethod"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip content="选择框不满足时,可以自己手动输入">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="收货地址" prop="shippingAddress">
          <div style="width: 500px;">
            <el-row type="flex" align="top">
              <el-col :span="20">
                <el-input
                    v-model="addForm.shippingAddress"
                    type="textarea"
                    :rows="2"
                    auto-complete="off"
                    style="width: 100%;"
                ></el-input>
              </el-col>
              <el-col :span="4" style="padding-left: 10px; display: flex; align-items: flex-start;">
                <addressSelector
                    :customer-id="customerId"
                    v-model="addForm.shippingAddress"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <h3>收款信息</h3>
        <el-form-item   label="收款方式" prop="payType">
          <el-input v-model="addForm.payType" style="width: 300px" placeholder="请输入收款方式">
          </el-input>
        </el-form-item>
        <el-form-item   label="支付状态" prop="paymentStatus">
          <el-radio v-model="addForm.paymentStatus" label="已支付" border>已支付</el-radio>
          <el-radio v-model="addForm.paymentStatus" label="欠款" border>欠款</el-radio>
        </el-form-item>
        <el-form-item label="收款凭证" prop="receipt">
          <el-upload
              class="upload-demo"
              name="file"
              :action="this.$uploadURL"
              :on-remove="handleFileRemove"
              :on-success="handleFileUpload"
              :on-exceed="handleFileExceed"
              :multiple="true"
              :limit="5"
              :file-list="fileList"
              accept=".jpg,.png,.gif"
              list-type="picture">
            <!--              :headers="{ Authorization: 'Bearer ' + localStorage.getItem('token') }">-->
            <el-button size="small" type="primary">点击上传</el-button>
            <!--            <div slot="tip" class="el-upload__tip">只能上传指定类型图片文件，且不超过500kb</div>-->
          </el-upload>
        </el-form-item>

        <el-form-item label="订单审核人" prop="orderReviewerId">
          <el-select v-model="addForm.orderReviewerId" placeholder="请选择审核人!">
            <el-option v-for="item in this.examines"
                       :key="item.id" :label="item.adminName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">创建订单</el-button>
      </div>
    </div>

    <ProductSelect :visible.sync="productFormVisible"  :selected-products-from-parent="productList"  @upload-products="handleUploadProducts"></ProductSelect>
  </div>

</template>
<script>
import util from '../../common/js/util'

export default {
  name:'CustomeraAddorder',
  data() {
    return {
      totalOrderAmount: 0.00, // 用于存储订单总金额
      purchaseNum:0,
      //传递过来的客户id
      customerId:'',
      customerType:'',
      customerSource:'',
      customerLabel:'',
      orderDetails: [], // 订单详情数组，包含产品ID、金额和数量
      sels: '',
      fileList: [],
      productFormVisible: false,//产品页面
      listLoading: false,
      productLists: [],
      productList: [],
      purchaseQuantity: '',
      selectedProductSet: new Set(),
      addLoading: false,
      addFormRules: {
        customerId:[{
          required: true, message: '请输入客户名称', trigger: 'blur'
        }],
        logisticsCompanies:[{
          required: true, message: '请输入快递公司', trigger: 'blur'
        }],
        logisticsMethods:[{
          required: true, message: '请输入发货方式', trigger: 'blur'
        }],
        orderReviewerId:[{
          required: true, message: '请输入订单审核人', trigger: 'blur'
        }],
        payType:[{
          required: true, message: '请输入收款方式', trigger: 'blur'
        }],
        paymentStatus:[{
          required: true, message: '请选择支付状态', trigger: 'blur'
        }],

        // receipt:[{
        //   required: true, message: '请上传支付凭证', trigger: 'blur'
        // }],
        shippingAddress:[{
          required: true, message: '请输入收货地址', trigger: 'blur'
        }],

      },

      //新增界面数据
      addForm: {
        customerId: '',
        orderSn: '',
        stash: '',
        logisticsCompanies: '',
        notes: '',
        logisticsMethods: '',
        productId: '',
        payType: '',
        receipt: [],
        loginId: '',
        productNumber: '',
        orderAmount: '',
        orderProducids:[],
        orderDetail: {
          id: '',
          name: '',
          phone: '',
          province: '',
          city: '',
          district: '',
          detailAddress: '',
        },
        orderReviewerId:'',

      },
      examines:[],
      //发货方式的选择
      ShippingMethod: [
        {label:"快递",value:"快递"},{label:"物流",value:"物流"},{label:"自提",value:"自提"},
        {label:"客户自己叫车",value:"客户自己叫车"},{label:"整车拉",value:"整车拉"},{label:"拉货车",value:"拉货车"},
      ],

      //订单审核人
      orderReviewer:{
        id:'',
        adminName: '',
      },
      customerLists: [],
      serousList: [],
      total: 0,
      currentPage: 1,
      keyword: "",
      totals: 0,
      pageSize: 5,
    }
  },
  created() {
    // 在组件创建时生成订单编号并设置为默认值
    this.addForm.orderSn = this.generateOrderSn();
    this.findExamine();
  },
  methods: {
    handleUploadProducts(selectedProducts) {
      // ✅ 避免重复添加
      selectedProducts.forEach(product => {
        if (!this.productList.some(p => p.id === product.id)) {
          this.productList.push(product);
          this.orderDetails.push({
            id: product.id,
            amount: 0,
            quantity: 0,
            salePrice: 0,
          });
        }
      });
      this.$message.success('产品添加成功');
    },
    //查询审核人有哪些
    findExamine(){
      this.$http.get('employee/examine').then(res => {
        this.examines=res.data;
      })
    },
    generateOrderSn() {
      // 生成订单编号的逻辑，这里使用当前时间的简单示例
      const currentTime = new Date();
      const year = currentTime.getFullYear();
      const month = (currentTime.getMonth() + 1).toString().padStart(2, '0');
      const day = currentTime.getDate().toString().padStart(2, '0');
      const hour = currentTime.getHours().toString().padStart(2, '0');
      const minute = currentTime.getMinutes().toString().padStart(2, '0');
      const second = currentTime.getSeconds().toString().padStart(2, '0');

      return `${year}${month}${day}${hour}${minute}${second}`;
    },
    calculateOrderAmount(product) {
      // 找到订单详情中是否已经存在该产品
      const orderDetail = this.orderDetails.find(detail => detail.id === product.id);

      // 确保 salePrice 和 purchaseQuantity 都有值，并处理空值情况
      const salePrice = product.salePrice || 0.00;
      const purchaseQuantity = product.purchaseQuantity || 0;

      // 计算金额并确保格式正确
      let amount = (salePrice * purchaseQuantity).toFixed(2);

      if (orderDetail) {
        // 更新已存在的订单详情
        orderDetail.amount = parseFloat(amount);
        orderDetail.quantity = purchaseQuantity;
        orderDetail.salePrice = salePrice;
      } else {
        // 新增订单详情
        this.orderDetails.push({
          id: product.id,
          amount: parseFloat(amount),
          quantity: purchaseQuantity,
          salePrice: salePrice
        });
      }

      // 统计所有产品的选购数量
      this.purchaseNum = this.orderDetails.reduce((total, detail) => {
        return total + detail.quantity;
      }, 0);

      // 重新计算总金额
      this.totalOrderAmount = this.orderDetails.reduce((total, detail) => {
        return total + detail.amount;
      }, 0);

      return parseFloat(amount);
    },
    renderOptionLabel(customer) {
      return `${customer.customerName} - ${customer.phoneNumber}`;
    },
    showProductDialog: function () {
        this.productFormVisible = true;
        this.getproductLists();
    },

    keywordQuery() {
      //查询完，原来分页条件已经没用了，要跑到第一页去
      this.currentPage = 1;
      this.getproductLists();
    },
    //关闭产品选择页面
    handleClose(){
      this.keyword='';
      this.currentPage = 1;
      this.pageSize = 5;
      this.totals = 0;
    },
//产品页面分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getproductLists();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 重置当前页码为1
      this.getproductLists();
    },
//获取产品数据
    getproductLists() {
      let para = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        keyWords: this.keyword
            ? this.keyword.split(',').map(name => name.trim()).filter(name => name)
            : [] // 如果 keyword 为空，则传递空数组
      };

      this.listLoading = true;
      this.$http.post("/productList/forSale", para).then((res) => {
        this.totals = res.data.total;
        // 处理每个产品的标签，将空格分隔的字符串转换为数组
        this.productLists = res.data.records.map(product => {
          return {
            ...product,
            label: product.label ? product.label.split(' ') : [] // 将空格分隔的字符串转换为数组
          };
        });
        this.listLoading = false;
      }).catch(res => {
        this.$message.warning("系统繁忙，请稍后重试!!!")
      });
    },


    //上传到订单
    uptoorder: function () {
      if (this.selectedProductSet.size >= 1) {
        // 获取选中的产品ID
        const uploadedProductId = Array.from(this.selectedProductSet);
        // 在productLists中找到选中的产品并添加到productList和orderDetails中
        uploadedProductId.forEach((uploadedProductId) => {
          const selectedProduct = this.productLists.find(product => product.id === uploadedProductId);
          if (!this.productList.some(product => product.id === selectedProduct.id)) {
            // 将选中的产品添加到productList中
            this.productList.push(selectedProduct);
            // 将选中的产品ID添加到orderDetails中
            this.orderDetails.push({
              id: selectedProduct.id,
              amount: 0,
              quantity: 0,
              salePrice:0,
            });
          }
        })

        // 清除selectedProductSet
        this.selectedProductSet.clear();
        // 关闭对话框
        this.productFormVisible = false;
      } else {
        // 提示用户只能选择一个产品
        this.$message.warning('请选择一个产品进行上传');
      }
    },


    cancelshowData(productId, row) {
      // 在 productList 中找到与当前 productId 相匹配的产品，并删除
      const index = this.productList.findIndex(product => product.id === productId);
      if (index !== -1) {
        this.productList.splice(index, 1);
      }

      // 删除 orderDetails 中具有相同产品 ID 的整个数据对象
      this.orderDetails = this.orderDetails.filter(detail => detail.id !== productId);
      // 重新计算总金额
      // 统计所有产品的选购数量
      this.purchaseNum = this.orderDetails.reduce((total, detail) => {
        return total + detail.quantity;
      }, 0);

      this.totalOrderAmount = this.orderDetails.reduce((total, detail) => {
        return total + detail.amount;
      }, 0);
    },

    handleFileRemove(file, fileList) {
      // 获取文件路径
      let filePath = '';
      if (file.response) {
        filePath = file.response.resultObj; // 上传之后删除
      } else {
        filePath = file.url; // 回显时删除
      }

      // 删除文件后端文件（可选）
      const fileName = filePath.replaceAll("/", "_");
      this.$http.delete("/minio/" + fileName).then(res => {
        if (res.data.success) {
          this.$message.success("删除成功");

          // ✅ 从 addForm.receipt 中删除该路径
          const index = this.addForm.receipt.indexOf(filePath);
          if (index !== -1) {
            this.addForm.receipt.splice(index, 1);
          }

        } else {
          this.$message.error("删除失败");
        }
      });
    },

    //文件上传成功之后的回调
    handleFileUpload(response) {
      if (response.success) {
        this.addForm.receipt.push(response.resultObj) ;
      }
    },
    //上传超过数量的回调
    handleFileExceed() {
      this.$message.error("不能上传多张图片");
    },

    //6.选项改变时触发
    selsChange: function (sels) {
      this.selectedProductSet = new Set(sels.map(item => item.id));

    },
    //11.新增
    addSubmit: function () {
      // 选择“已支付”时，必须上传支付凭证
      if (
          this.addForm.paymentStatus === '已支付' &&
          (!this.addForm.receipt || this.addForm.receipt.length === 0)
      ) {
        this.$message.error('已支付状态下，必须上传支付凭证');
        return;
      }

      this.$refs.addForm.validate((valid) => {
        if (!valid) return;

        // ✅ 1. 商品明细字段校验
        const orderProductIdList = [];
        for (const detail of this.orderDetails) {
          const productId = detail.id;
          const price = detail.salePrice || detail.price;
          const quantity = detail.quantity || detail.num;
          const amount = detail.amount || price * quantity;

          if (!productId) {
            this.$message.error('商品明细中存在未选择的商品');
            return;
          }
          if (!price || price <= 0) {
            this.$message.error('商品明细中存在价格为空或为 0 的商品');
            return;
          }
          if (!quantity || quantity <= 0) {
            this.$message.error('商品明细中存在数量为空或为 0 的商品');
            return;
          }

          orderProductIdList.push({
            productId,
            salePrice: price,
            orderNum: quantity,
            orderAmount: amount,
          });
        }

        // ✅ 2. 创建订单确认
        this.$confirm('确定创建新订单吗', '提示', {}).then(() => {
          this.addLoading = true;

          const logininfo = JSON.parse(localStorage.getItem('logininfo'));
          this.addForm.loginId = logininfo.id;
          this.addForm.customerId = this.customerId;
          this.addForm.orderProducids = orderProductIdList;

          const para = Object.assign({}, this.addForm);
          para.receipt = para.receipt.join(',');

          this.$http.put('/orderList/saveOrder', para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: '订单创建成功，等待审核中!',
                type: 'success',
              });

              this.$router.push({
                path: '/CustomSalesman',
              });

              this.$refs['addForm'].resetFields();
              this.orderDetails = [];
            } else {
              this.$message.warning('系统繁忙，请稍后重试!!!');
            }
          });

          this.addLoading = false;
        });
      });
    },

  },
  mounted() {
    // this.getcustomerLists();
    // this.getOrderReviewer();
    const { customerId, customerName,customerType,customerLabel,customerSource} = this.$route.params.orderData;
    // 将客户名称回显到表单中
    this.customerId = customerId;
    this.addForm.customerId = customerName;
    this.customerType=customerType;
    this.customerLabel=customerLabel;
    this.customerSource=customerSource;

  }
}

</script>
<style>
.form-container {
  margin-top: 50px;
  margin-left: 10px;
  width: 1000px;
  height: 800px;
}
</style>
<style scoped>
.tag-container {
  display: flex;
  align-items: center; /* 让标签垂直居中显示 */
  flex-wrap: wrap;
}

.tag-label {
  background-color: #e6f1fe;
  color: #1d8ce0;
  padding: 4px 8px;
  border-radius: 4px;
  margin-right: 8px; /* 间隔大小可以根据需要调整 */
  margin-bottom: 3px;
  white-space: nowrap; /* 防止文字换行 */
  display: inline-block; /* 让每个标签作为一个块级元素显示 */
}


</style>



// WEBPACK FOOTER //
// CustomeraAddorder.vue?3ecc854c